





































































import * as Vue from '@vue/composition-api'
import acceItems from '@/ts/model/acceItems'
import charaOptions from '@/ts/model/charaOptions'

export default Vue.createComponent({
  name: 'StageController',
  props: {
    hairName: {
      type: String
    },
    dressName: {
      type: String
    },
    enableForward: {
      type: Boolean,
      default: false
    },
    enableBackward: {
      type: Boolean,
      default: false
    },
    enableAdd: {
      type: Boolean,
      default: false
    },
    enableDelete: {
      type: Boolean,
      default: false
    }
  },
  setup (props, ctx) {
    const acceDefs = Vue.computed(() => {
      return Object.values(acceItems).filter(item => item.type !== 'chara')
    })
    const charaHairOptionDefs = Vue.computed(() => {
      return Object.values(charaOptions).filter(op => op.type === 'hair')
    })
    const charaDressOptionDefs = Vue.computed(() => {
      return Object.values(charaOptions).filter(op => op.type === 'dress')
    })

    const addItem = (name: string) => {
      ctx.emit('add', name)
    }
    const changeHair = (name: string) => {
      ctx.emit('changeHair', name)
    }
    const changeDress = (name: string) => {
      ctx.emit('changeDress', name)
    }
    const goForward = () => {
      ctx.emit('forward')
    }
    const goBackward = () => {
      ctx.emit('backward')
    }
    const deleteItem = () => {
      ctx.emit('delete')
    }

    return {
      acceDefs,
      charaHairOptionDefs,
      charaDressOptionDefs,
      addItem,
      changeHair,
      changeDress,
      goForward,
      goBackward,
      deleteItem
    }
  }
})
